import React from 'react';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import Spinner from '@atlaskit/spinner';
import { Flex } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	loadingContainer: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});
export const LoadingSpinner = () => (
	<Flex justifyContent="center" alignItems="center" xcss={styles.loadingContainer}>
		<Spinner testId="share-dialog.common.ui.loading" size="medium" />
	</Flex>
);
